<template>
    <article class="llmBlock" :class="params.class">
        <h3 v-if="title">{{ title }}</h3>
        <div class="llmBlock__inline">
            <div class="llmBlock__field">
                <label>Сеть</label>
                <el-select
                        v-model="localLlm"
                        @change="handleLlmChange"
                        @clear="handleClear"
                        class="llmBlock__select--llm"
                        clearable
                >
                    <el-option
                            v-for="llm in llms"
                            :key="llm.alias"
                            :value="llm.alias"
                            :label="llm.name"
                    />
                </el-select>
            </div>

            <div class="llmBlock__field">
                <label>Шаблон LLM</label>
                <el-select
                        v-model="localTemplate"
                        @change="handleTemplateChange"
                        class="llmBlock__select--template"
                        :disabled="!localLlm"
                >
                    <el-option
                            v-for="tpl in currentTemplates"
                            :key="tpl.alias"
                            :value="tpl.alias"
                            :label="tpl.alias"
                    />
                </el-select>
            </div>
        </div>
    </article>
</template>

<script>
    import { mapState } from "vuex";

    export default {
        name: "LlmBlock",
        props: {
            llm: {
                type: Object,
                default: () => ({
                    llm: "",
                    template: "",
                    paramsMapping: { input: "input", docs: "docs" },
                    params: {}
                })
            },
            params: {
                type: Object,
                default: () => ({})
            },
            title: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                // Локальные состояния для v-model, чтобы не мутировать пропсы напрямую
                localLlm: '',
                localTemplate: '',
            };
        },
        computed: {
            ...mapState('smartSearch', ['llms']),

            // Вычисляемый список шаблонов на основе выбранной LLM
            currentTemplates() {
                if (!this.localLlm) return [];
                const selectedLlm = this.llms.find(item => item.alias === this.localLlm);
                return selectedLlm?.templates || [];
            }
        },
        watch: {
            // Синхронизация при загрузке компонента или изменении пропсов извне
            'llm.llm': {
                handler(val) {
                    this.localLlm = val || '';
                },
                immediate: true
            },
            'llm.template': {
                handler(val) {
                    this.localTemplate = val || '';
                },
                immediate: true
            }
        },
        methods: {
            handleLlmChange(alias) {
                this.llm.llm = alias;
                // При смене LLM сбрасываем шаблон, как в оригинале
                this.localTemplate = '';
                this.llm.template = '';
            },

            handleTemplateChange(tpl) {
                this.llm.template = tpl;
            },

            handleClear() {
                // Логика очистки (вызывается el-select при нажатии на крестик)
                this.localTemplate = '';
                this.llm.template = '';
            }
        }
    };
</script>

<style scoped lang="scss">
    @use "@/assets/variables.scss" as *;

    .llmBlock {
        h3 {
            &:first-child {
                margin-top: 0;
            }
        }

        &__inline {
            display: flex;
            gap: 30px;
            flex-wrap: wrap;
        }

        &__field {
            display: flex;
            align-items: center;
            gap: 5px;
        }

        // Замена инлайн стилей
        &__select--llm {
            width: 375px;
        }

        &__select--template {
            width: 275px;
        }
    }
</style>